var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18 32.05L24.745 38l9.726-11.765"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M4.706 22.516h12.647v.013H4.706zM4.706 17.808h14.647v.016H4.706zM4.706 13.112h16.647v.006H4.706zM4.706 8.385h10.588v.027H4.706z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#041A32",
    d: "M9.614 33H1V1h23.946L25 22.666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f063cfb211c07704b5833a21f720474e.svg";
export { ForwardRef as ReactComponent };